import { render, staticRenderFns } from "./TextblockSingle.vue?vue&type=template&id=5609d6a8"
import script from "./TextblockSingle.vue?vue&type=script&lang=js"
export * from "./TextblockSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports